export default __webpack_public_path__ + "static/media/press-11.7573c234.jpg";